import ApiService from './api.service';

const AdminToolService = token => {
    const api = ApiService.createApiInstance(token);

    return {
        dumpRedisDB() {
            return api.delete('/admin-tools/dump-redis-cache');
        },
        directAddVideo(eventId, videoUrl) {
            return api.post(`/videos/direct-add/${eventId}`, {
                convertedFilePath: videoUrl,
            });
        },
    };
};

export default AdminToolService;
